import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Download } from "lucide-react";

interface Props {
    src: string;
    alt: string;
    downloadName: string;
    onClose: () => void;
}

export default function ImageModal({src, alt, onClose, downloadName}: Props) {
    return (
        <Dialog open onOpenChange={onClose}>
            <DialogContent className="p-0 overflow-hidden">
                <div className="relative">
                    <img src={src} alt={alt} className="max-h-[80vh] w-full object-contain" />
                    <a
                        href={src}
                        download={downloadName}
                        target="_blank"
                        className="absolute top-2 left-2 bg-primary/80 rounded-full p-1"
                    >
                        <Download className="h-5 w-5" />
                    </a>
                </div>
            </DialogContent>
        </Dialog>
    );
}